import Styles from '../ElementsTab.module.scss'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { createShapeId, track } from '@tldraw/tldraw'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { GeoShapeProps } from 'components/VisualStudioPlayground/Shapes/GeoShape/Types'
import { Element } from './Element'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ReactComponent } from 'react-hotkeys'

interface Props {
  shapesToDisplay: {
    geo: GeoShapeProps['geo']
    label: string
    props?: Partial<GeoShapeProps>
    component: ReactComponent
  }[]
}

export const GeoShapesGrid = track(
  observer(({ shapesToDisplay }: Props) => {
    const editor = useEditor()
    const { drawersStore } = useRootStore()

    const defaultFillColor = getComputedStyle(document.documentElement).getPropertyValue('--avatar')

    const defaultProps = {
      w: 300,
      h: 300,
      fill: {
        type: 'solidColor',
        opacity: 1,
        color: defaultFillColor,
      },
    } as const

    const insertGeoShape = (geo: GeoShapeProps['geo'], partialProps?: Partial<GeoShapeProps>) => {
      if (!editor) return

      const frame = getCurrentFrame(editor)
      const props = {
        ...defaultProps,
        ...partialProps,
        geo,
      }

      editor.batch(() => {
        const id = createShapeId()
        editor.createShape({
          id,
          type: 'geometric',
          parentId: frame.id,
          x: frame.props.w / 2 - props.w / 2,
          y: frame.props.h / 2 - props.h / 2,
          props,
        })
        editor.select(id)
      })
      drawersStore.closeDrawer()
    }

    return (
      <div className={Styles.groupItems}>
        {shapesToDisplay.map((shape, i) => (
          <Element
            aria-label={shape.label}
            key={`${shape.geo}-${i}`}
            onPress={(_ev, thumbnailDimensions) => {
              insertGeoShape(shape.geo, {
                ...shape.props,
                ...thumbnailDimensions,
              })
            }}
            shape={{
              type: 'geometric',
              props: {
                ...defaultProps,
                geo: shape.geo,
              },
            }}
          >
            <shape.component />
          </Element>
        ))}
      </div>
    )
  }),
)
